import { IStatus } from './../Models/status';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CenterService {

  constructor(private http: HttpClient) { }
  public GetCenter(id: string): Observable<IStatus> {
    let param = new HttpParams();
    param = param.append('id', id);
    return this.http.get<IStatus>('/api/TestCenter/GetTestCenter', {params: param});
  }
}
